<div class="container-fluid h-100">
  <div class="row h-100">
    <as-split direction="horizontal" [gutterSize]="20">
      <as-split-area [size]="50" [order]="1">
        <div class="ml-4 flex-column h-100">
          <div class="d-flex flex-column h-100">
            <div class="d-flex align-items-center px-2">
              <div class="mr-2">
                <button
                  (click)="loadItems()"
                  [ngClass]="{
                    'btn-success': isLoading,
                    'btn-light': !isLoading
                  }"
                  class="btn btn-sm"
                >
                  <i
                    [ngClass]="{ 'la-spin': isLoading }"
                    class="la la-refresh"
                  ></i>
                </button>
              </div>
              <fieldset>
                <div class="mr-2" style="float: left">
                  <button
                    (click)="showAddLifecycleModelModal()"
                    [disabled]="isLoading || auth.isViewer('fastlc')"
                    class="btn btn-success btn-sm"
                  >
                    <i class="la la-plus"></i>
                  </button>
                </div>
                <div
                  [isDisabled]="
                    selectedLifecycleModelNodes.length === 0 || isLoading
                  "
                  class="btn-group mr-1"
                  dropdown
                >
                  <button
                    class="dropdown-toggle btn btn-sm btn-primary"
                    dropdownToggle
                    type="button"
                  >
                    <ng-container *ngIf="selectedLifecycleModelNodes.length > 0"
                      >{{ "navigations.with" | translate }}
                      <strong>{{ selectedLifecycleModelNodes.length }}</strong>
                      {{ "navigations.selected" | translate }}
                    </ng-container>
                    <ng-container
                      *ngIf="selectedLifecycleModelNodes.length === 0"
                      >{{
                        "navigations.no_selection" | translate
                      }}</ng-container
                    >
                    <span class="caret"></span>
                  </button>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li
                      (click)="duplicateModels()"
                      class="btn btn-sm dropdown-item"
                      *ngIf="!auth.isViewer('fastlc')"
                    >
                      <i class="la la-fw la-clone"></i>
                      {{ "navigations.clone" | translate }}
                    </li>
                    <li
                      (click)="lifecycleModelsGrid?.export('xlsx')"
                      class="btn btn-sm dropdown-item"
                    >
                      <i class="la la-fw la-file-excel"></i> XLSX
                    </li>
                    <li
                      (click)="lifecycleModelsGrid?.export('csv')"
                      class="btn btn-sm dropdown-item"
                    >
                      <i class="la la-fw la-file-csv"></i> CSV
                    </li>
                    <li
                      class="divider dropdown-divider"
                      *ngIf="!auth.isViewer('fastlc')"
                    ></li>
                    <li role="menuitem" *ngIf="!auth.isViewer('fastlc')">
                      <a
                        class="dropdown-item btn btn-sm btn-danger"
                        (click)="showMassDeleteConfirm()"
                      >
                        <i class="la la-fw la-trash"></i>
                        {{ "navigations.delete" | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
            <div class="d-flex h-100 w-100 flex-grow-1 pt-2 ag-grid-container">
              <app-grid
                (filterChanged)="onFilterChanged($event)"
                (rowDoubleClicked)="
                  auth.isViewer('fasrlc') ? null : onRowClicked($event)
                "
                (selectionChanged)="onSelectionChanged($event)"
                [gridOptions]="gridOptions"
                [rowData]="items"
                class="ag-theme-alpine"
                style="width: 100%; height: 100%"
              >
              </app-grid>
            </div>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="50" [order]="2">
        <div class="mr-4 h-100">
          <app-conditions
            *ngIf="childGrid === 'condition'"
            class="flex-column"
            [sizeColumnsToFit]="sizeColumnsToFit"
            (changeSelectLifecycleModelNodes)="
              updateSelectedLifecycleModelNodes($event)
            "
            (resetModelsGrid)="resetModelsGrid()"
            (changeChildGrid)="changeChildGrid()"
            [selectedLifecycleModelNodes]="selectedLifecycleModelNodes"
          ></app-conditions>
          <app-actions
            *ngIf="childGrid === 'action'"
            class="flex-column"
            [sizeColumnsToFit]="sizeColumnsToFit"
            (changeSelectLifecycleModelNodes)="
              updateSelectedLifecycleModelNodes($event)
            "
            (resetModelsGrid)="resetModelsGrid()"
            (changeChildGrid)="changeChildGrid()"
            [selectedLifecycleModelNodes]="selectedLifecycleModelNodes"
          ></app-actions>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>
